export default __webpack_public_path__ + "static/media/kitchen3-before3-768w.dbb9e989.webp";